import { enumItems } from './enumItems';
import { enumItemsWithColor } from './enumItemsWithColor';
import { statuses } from './statuses';
import { group } from './group';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { Group } from '../types/entities/Group';
import { NumberField } from '../components/Table/fields/NumberField';
import { SelectField } from '../components/Table/fields/SelectField';
import { DateField } from '../components/Table/fields/DateField';
import { TextField } from '../components/Table/fields/TextField';
import { BooleanField } from '../components/Table/fields/BooleanField';
import { salesPartner } from './salesPartner';
import { roomType } from './roomType';
import { SelectFieldWithoutAutocomplete } from '../components/Table/fields/SelectFieldWithoutAutocomplete';
import { RichTextField } from '../components/Table/fields/RichTextField';
import { SPRichTextField } from '../components/Table/fields/SPRichTextField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { SPBooleanField } from '../components/Table/fields/SPBooleanField';
import { accommodation } from './accommodation';
import {SPSelectWithOutAutocomplete} from "../components/Table/fields/SPSelectWithOutAutocompleteField";
import {SPTimeField} from "../components/Table/fields/SPTimeField";
import {FileField} from "../components/Table/fields/FileField";
import {AccommodationReservationComment} from "../components/Comment/AccommodationReservationComment";
import {CustomFieldForAccommodationRoom} from "../components/Table/fields/CustomFieldForAccommodationRoom";
import {SetField} from "../components/Table/fields/SetField";
import {SPSetField} from "../components/Table/fields/SPSetField";
import {room} from "./room";

export const accommodationReservation = (
  forGroupId?: Group['id']
): SchemaWithClient<any> => ({
  name: 'Accommodation Reservation',
  pluralName: 'Accommodation',
  breadcrumb: ['Group', 'Accommodation Reservation'],
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],

  sections: [
    {
      id: 1,
      width: 6,
      label: 'General Data',
      name: 'general',
      grids: [
        {
          width: 6,
          columns: [
            {
              columnName: 'accommodation',
              name: 'Accommodation Provider',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.accommodation),
              readOnly: true,
            },
            {
              columnName: 'group',
              name: 'Group',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.group),
              readOnly: true,
            },

            {
              grid: true,
              columns: [
                {
                  columnName: 'checkin_time',
                  name: 'Checkin Time',
                  fieldRenderer: SPTimeField,
                },
                {
                  columnName: 'checkout_time',
                  name: 'Checkout Time',
                  fieldRenderer: SPTimeField,
                },
              ],
            },

            {
              columnName: 'booked_by',
              name: 'Booked By',
              fieldRenderer: SPSelectField.tableAdapter(enumItemsWithColor.bookedBy),
            },
          ],
        },
        {
          width: 6,
          columns: [
            {
              columnName: 'reservation_status',
              name: 'Status',
              fieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(
                statuses.serviceReservationStatus
              ),
            },
            {
              columnName: 'reservation_type',
              name: 'Type',
              fieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(
                enumItems.accommodationReservationType
              ),
            },
            {
              grid: true,
              columns: [
                {
                  columnName: 'arrival',
                  name: 'Arrival',
                  fieldRenderer: SPDateField,
                },
                {
                  columnName: 'departure',
                  name: 'Departure',
                  fieldRenderer: SPDateField,
                },
              ],
            },
            {
              grid: true,
              columns: [
                {
                  columnName: 'size',
                  name: 'Size',
                  fieldRenderer: SPNumberField,
                },
              ],
            },
            {
              grid: true,
              columns: [
                {
                  columnName: 'sales_partner',
                  name: 'Sales Partner',
                  fieldRenderer: SPSelectField.tableAdapter(enumItems.salesPartner),
                },
                {
                  columnName: 'breakfast_included',
                  name: 'Breakfast Included',
                  fieldRenderer: SPBooleanField,
                },
              ],
            },

          ],
        },

      ]
    },
    {
      id: 2,
      width: 6,
      label: 'Chat',
      name: 'chat',
      hasDefaultButtons: true,
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'chat',
              fieldRenderer: AccommodationReservationComment,
            },
          ],
        },
        {
          width: 12,
          columns: [
            {
              grid: true,
              columns: [
               /* {
                  columnName: 'custom_fields',
                  name: 'Custom Fields',
                  fieldRenderer: FullWidthCustomFields,
                },*/
                {
                  columnName: 'confirms',
                  name: 'Confirmation File',
                  fieldRenderer: FileField,
                },
              ],
            },
          ],
        },

      ],
    },

    {
      id: 3,
      width: 12,
      label: 'Rooms',
      name: 'rooms',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'rooms',
              name: '',
              fieldRenderer: CustomFieldForAccommodationRoom,
            },
          ]
        }
      ],
    },

    {
      id: 3,
      width: 12,
      label: 'Finances',
      name: 'finances',
      grids: [
        {
          width: 12,
          columns: [

            {
              grid: true,
              columns: [
                {
                  columnName: 'deposit_amount',
                  name: 'Deposit Amount',
                  fieldRenderer: SPNumberField,
                },
                {
                  columnName: 'deposit_deadline',
                  name: 'Deposit Deadline',
                  fieldRenderer: SPDateField,
                },
                {
                  columnName: 'deposit_paid',
                  name: 'Deposit Paid',
                  fieldRenderer: SPDateField,
                },
                {
                  columnName: 'damage_deposit',
                  name: 'Damage Deposit',
                  fieldRenderer: SPNumberField,
                },
              ],
            },

            {
              grid: true,
              columns: [
                {
                  columnName: 'full_amount',
                  name: 'Full Amount',
                  fieldRenderer: SPNumberField,
                },
                {
                  columnName: 'full_amount_deadline',
                  name: 'Full Amount Deadline',
                  fieldRenderer: SPDateField,
                },
                {
                  columnName: 'full_amount_paid',
                  name: 'Full Amount Paid',
                  fieldRenderer: SPDateField,
                },
              ],
            },
            {
              grid: true,
              columns: [
                {
                  columnName: 'total_cost',
                  name: 'Total Gross Cost',
                  fieldRenderer: SPNumberField,
                },
                {
                  columnName: 'gross_cost_person_night',
                  name: 'Gross Cost PP/Night',
                  fieldRenderer: SPNumberField,
                },
                {
                  columnName: 'cost_ifa_percent',
                  name: 'Cost IFA Percent',
                  fieldRenderer: SPNumberField,
                },
                {
                  columnName: 'cost_vat_percent',
                  name: 'Cost VAT Percent',
                  fieldRenderer: SPNumberField,
                },
              ],
            },
            {
              grid: true,
              columns: [
                {
                  columnName: 'cost_currency',
                  name: 'Cost Currency',
                  fieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(enumItems.currency),
                },
                {
                  columnName: 'gross_cost_person_night',
                  name: 'Gross Cost PP/Night',
                  fieldRenderer: SPNumberField,
                },
                {
                  columnName: 'cost_ifa_percent',
                  name: 'Cost IFA Percent',
                  fieldRenderer: SPNumberField,
                },
                {
                  columnName: 'cost_vat_percent',
                  name: 'Cost VAT Percent',
                  fieldRenderer: SPNumberField,
                },
              ],
            },

            {
              grid: true,
              columns: [
                {
                  columnName: 'total_price',
                  name: 'Total Gross Price',
                  fieldRenderer: SPNumberField,
                },
                {
                  columnName: 'sales_price_person_night',
                  name: 'Sales Price PP/Night',
                  fieldRenderer: SPNumberField,
                },
                {
                  columnName: 'Price VAT Percent',
                  name: 'Price VAT Percent',
                  fieldRenderer: SPNumberField,
                },
                {
                  columnName: 'price_currency',
                  name: 'Price Currency',
                  fieldRenderer: SPSelectField.tableAdapter(enumItems.currency),
                },
              ],
            },
          ],
        },
        {
          width: 6,
          columns: [

          ],
        },

      ],
    },
    {
      id: 5,
      width: 12,
      label: 'Notes',
      name: 'notes',
      grids: [
        {
          width: 4,
          columns: [
            {
              columnName: 'guide_notes',
              name: 'Guide Notes',
              fieldRenderer: SPRichTextField,
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              columnName: 'office_notes',
              name: 'Office Notes',
              fieldRenderer: SPRichTextField,
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              columnName: 'group_notes',
              name: 'Group Notes',
              fieldRenderer: SPRichTextField,
            },
          ],
        },
      ],
    },

  ],

  columns: {
    accommodation: {
      name: 'Provider',
      required: false,
      fieldRenderer: SelectField.tableAdapter(accommodation),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(accommodation),
      url: accommodation.client.getAllPath,
      tempSchema: accommodation,
      switchboard: true,
    },
    group: {
      name: 'Group',
      required: false,
      fieldRenderer: SelectField.tableAdapter(group),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(group),
      switchboard: true,
      readOnly: true,
      url: group.client.getAllPath,
      tempSchema: group,
      width: 'small',
    },
    reservation_type: {
      name: 'Type',
      fieldRenderer: SelectField.tableAdapter(enumItems.accommodationReservationType),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.accommodationReservationType
      ),
      url: enumItems.accommodationReservationType.client.getAllPath,
      tempSchema: enumItems.accommodationReservationType,
      switchboard: true,
    },
    reservation_status: {
      name: 'Status',
      fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
        statuses.serviceReservationStatus
      ),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        statuses.serviceReservationStatus
      ),
      url: statuses.serviceReservationStatus.client.getAllPath,
      tempSchema: statuses.serviceReservationStatus,
      switchboard: true,
      fieldType: 'status',
      editOnlyByAdmin: true
    },
    booked_by: {
      name: 'Booked By',
      fieldRenderer: SelectField.tableAdapter(enumItemsWithColor.bookedBy),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItemsWithColor.bookedBy
      ),
      url: enumItemsWithColor.bookedBy.client.getAllPath,
      tempSchema: enumItemsWithColor.bookedBy,
      switchboard: true,
      width: 'medium',
    },
    arrival: {
      name: 'Arrival',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      width: 'medium',
      collapseHeader: true,
    },
    departure: {
      name: 'Departure',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      width: 'medium',
      collapseHeader: true,
    },
    checkin_time: {
      name: 'Checkin Time',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
    },
    checkout_time: {
      name: 'Checkout Time',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
    },
    send_docs: {
      name: 'Send Docs',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },
    confirms: {
      name: 'Confirmation File',
      fieldRenderer: FileField,
      slidePaneFieldRenderer: FileField,
      fieldType: 'file',
    },

    sales_partner: {
      name: 'Sales Partner',
      fieldRenderer: SelectField.tableAdapter(salesPartner),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(salesPartner),
      switchboard: true,
      url: salesPartner.client.getAllPath,
      tempSchema: salesPartner,
    },
    size: {
      name: 'Size',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      collapseHeader: true,
    },

    rooms: {
      name: 'Rooms',
      fieldRenderer: SetField.tableAdapter(room),
      slidePaneFieldRenderer: SPSetField.tableAdapter(room),
      url: room.client.getAllPath,
      tempSchema: room,
      multiSwitchboard: true,
    },

    breakfast_included: {
      name: 'Breakfast Included',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },

    deposit_amount: {
      name: 'Deposit Amount',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      width: 'small',
    },
    deposit_deadline: {
      name: 'Deposit Deadline',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      width: 'small',
    },
    deposit_paid: {
      name: 'Deposit Paid',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      width: 'small',
    },
    full_amount: {
      name: 'Full Amount',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      width: 'small',
    },
    full_amount_deadline: {
      name: 'Full Amount Deadline',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      width: 'small',
    },
    full_amount_paid: {
      name: 'Full Amount Paid',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      width: 'small',
    },
    damage_deposit: {
      name: 'Damage Deposit',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },

    total_cost: {
      name: 'Total Gross Cost',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    gross_cost_person_night: {
      name: 'Gross Cost Person/Night',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      width: 'extra-small',
    },
    cost_ifa_percent: {
      name: 'Cost IFA Percent',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      required: true,
    },
    cost_vat_percent: {
      name: 'Cost VAT Percent',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      required: true,
    },
    cost_currency: {
      name: 'Cost Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(enumItems.currency),
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
      switchboard: true,
      width: 'extra-small',
    },

    total_price: {
      name: 'Total Gross Price',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    sales_price_person_night: {
      name: 'Sales Price Person/Night',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      width: 'small',
    },
    price_vat_percent: {
      name: 'Price VAT Percent',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      width: 'small',
    },
    price_currency: {
      name: 'Price Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.currency),
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
      switchboard: true,
      width: 'small',
    },

    guide_notes: {
      name: 'Guide Notes',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
    },
    office_notes: {
      name: 'Office Notes',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
    },
    group_notes: {
      name: 'Group Notes',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
      width: 'small',
    },
  },
  client: new Client(
    '/accommodation-reservations',
    forGroupId !== undefined
      ? `/groups/${forGroupId}/accommodation-reservations`
      : undefined
  ),
  viewTable: 'accommodation_reservations',
});
